import { configureStore } from "@reduxjs/toolkit"
import popupReducer from "./slices/popupCenterSlice"
import authSlice from "./slices/authenticationSlice"
import profileSlice from "./slices/profileSlice"
import filterReducer from "./slices/filterSlice"
import supportSlice from "./slices/supportSlice"
export const store = configureStore({
    reducer: {
        popup: popupReducer,
        auth: authSlice,
        profile: profileSlice,
        filter: filterReducer,
        support: supportSlice,
    },
})
